import { useEffect } from "react";
import { useAppDispatch } from "../hooks";
import { logoutAction } from "../redux/actions/authAction";
import { useSnackbarContext } from "../providers/SnackbarProvider";

const CHECK_INTERVAL_MS = 30000; // Check every 30 seconds

export const useSystemTrayCheck = (isEnabled: boolean) => {
    const dispatch = useAppDispatch();
    const snackbar = useSnackbarContext();

    useEffect(() => {
        if (!isEnabled) return;

        const checkSystemTrayApp = async () => {
            try {
                const storedCashier = localStorage.getItem("cashier");
                if (!storedCashier) return; // If no cashier data, nothing to compare against (or handled elsewhere)

                const parsedCashier = JSON.parse(storedCashier);
                const storedDeviceId = parsedCashier?.grantedDevice?.deviceId;

                if (!storedDeviceId) return; // Should probably be handled, but for now skip if no device ID stored

                const response = await fetch("http://localhost:8535/device-id");
                if (!response.ok) {
                    throw new Error("Local app unreachable");
                }

                const data = await response.json();
                const localDeviceId = data.deviceId;

                if (localDeviceId !== storedDeviceId) {
                    console.error(`Device ID mismatch! Local: ${localDeviceId}, Stored: ${storedDeviceId}`);
                    handleLogout("Device validation failed: ID mismatch. Logging out.");
                }

            } catch (error) {
                console.error("System tray app check failed:", error);
                handleLogout("System tray app not detected. Please ensure it is running. Logging out.");
            }
        };

        const handleLogout = (message: string) => {
            snackbar.showSnackbar(message, "error");
            dispatch(logoutAction());
        };

        // Run check immediately on mount/enable
        checkSystemTrayApp();

        const intervalId = setInterval(checkSystemTrayApp, CHECK_INTERVAL_MS);

        return () => clearInterval(intervalId);
    }, [isEnabled, dispatch, snackbar]);
};
